import {Observable} from "rxjs";
import {BaseError} from "../../models/error/BaseError";
import {Injectable} from "@angular/core";
import {ErrorFilter} from "../../models/filter/ErrorFilter";
import {LoggableErrorEntityService} from "./loggable-error-entity.service";
import { ErrorPriority } from "../../enums/ErrorPriority";

@Injectable({
    providedIn: 'root'
})
export abstract class BaseErrorService<T extends BaseError> extends LoggableErrorEntityService<T> {
    protected readonly necessaryBaseErrorFields: string[] = [
        "ApplicationId",
        "TenantId",
        "ErrorPriority",
        "Id",
        "CreatedAt",
        "UpdatedAt",
        "IsSolved",
        "Solution",
        "ErrorLogs",
        "MostRecentOccurred",
        "OccurrenceCount"
    ];

    public abstract updateErrorType(errors: T, newPriority: ErrorPriority): Observable<void>;

    public abstract solveError(error: T): Observable<void>;

    protected applyBaseErrorFiltersForAllErrorItems(errorFilter: ErrorFilter) {
        this.queryBuilder
            .addFilter("IsSolved eq false")
            .addEmptyCollectionFilter("RelatedLogBookIds")
            .addFilterForCollectionWithNestedObjects("ErrorLogs", "error", [
                `Occurred gt ${errorFilter.occurredTimeRange.from.toISOString()}`,
                `Occurred lt ${errorFilter.occurredTimeRange.to.toISOString()}`
            ])
            .addOrderBy("ErrorPriority", "desc")
            .addOrderBy("MostRecentOccurred", "desc");
    }

    protected createODataQueryForSpecificErrorItem(id: string): string {
        this.queryBuilder
            .addFilter("Id eq " + id)
            .addExpand("ErrorLogs($top=20;$orderby=Occurred desc)");

        return this.queryBuilder.build();
    }

    protected getNecessaryFieldsForErrors(): string[] {
        return this.necessaryBaseErrorFields;
    }
}
